import { SpacerProps } from 'layout/spacer/spacer.props';

export const SpacerPresets: SpacerProps = {
  height: {
    lg: 's3',
    md: 's2',
  },
};
